<template>
  <div class="detailsBox">
    <div class="detailsMain">
      <!-- <div class="detailsHead ft16">
        <ul>
          <ul>
            <li></li>
            <router-link tag="li" to="index">履约管理 &nbsp;&gt;&nbsp;</router-link>
            <li>履约任务&nbsp;&gt;&nbsp;</li>
            <router-link tag="li" to="mission">履约任务列表&nbsp;&gt;&nbsp;</router-link>
            <li>履约详情</li>
          </ul>
        </ul>
      </div>-->
      <breadcrumb>
        <el-breadcrumb slot="breadcrumb" separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/personal/performance/list' }">履约列表</el-breadcrumb-item>
          <el-breadcrumb-item
            :to="{ path: `/personal/performance/mission?id=${proforeTaskVo.contractId}` }"
          >履约任务列表</el-breadcrumb-item>
          <el-breadcrumb-item>履约详情</el-breadcrumb-item>
        </el-breadcrumb>
      </breadcrumb>
      <div class="detailsCon" v-if="currentStatus&&result">
        <div class="detailsConHead">
          <el-form>
            <el-form-item label="合同名称：">{{result.contractName}}</el-form-item>
            <el-form-item label="履约任务名称：">{{result.taskName}}</el-form-item>
            <el-form-item label="合同有效期限：">{{result.contractEndDate}}</el-form-item>
            <el-form-item label="履约创建时间：">{{result.performCreateTime}}</el-form-item>
            <el-form-item label="履约任务说明：">{{result.description}}</el-form-item>
          </el-form>
          <el-form>
            <el-form-item label="任务执行方：">{{result.performUserName}}</el-form-item>
            <el-form-item label="任务确认方：">{{result.confirmUserName}}</el-form-item>
            <el-form-item label="最晚执行时间：">{{result.taskCommitTime}}</el-form-item>
            <el-form-item label="最晚确认时间：">{{result.taskConfirmTime}}</el-form-item>
          </el-form>
        </div>
        <div class="detailsSwiper">
          <p class="detailsID" v-if="perFormRecordList&&perFormRecordList.length">
            创建履约任务区块链记录ID:
            <span>{{perFormRecordList[0].txId}}</span>
            <span class="fr">{{currentStatus.perFormStatusName}}</span>
            <span class="fr" v-if="currentStatus.actionType!=1">{{currentStatus.confirmStatusName}}</span>
          </p>
          <div class="preSwiperCom" v-loading="showLoading" element-loading-text="正在加载中">
            <div class="swiper-button-pre-prev" slot="button-prev">
              <span class="flag"></span>
            </div>
            <swiper
              :options="swiperOption"
              class="swiperCustomer cursorPointer"
              v-if="perFormRecordList&&perFormRecordList.length"
            >
              <!-- <div class="banners"> -->
              <swiper-slide
                class="swiperSlidecustomer swiperSlidecustomerComplete"
                v-for="(item,index) in perFormRecordList"
                :key="index"
              >
                <div class="swiperCon">
                  <div class="swiperHead">
                    区块链记录ID:
                    <br>
                    <span>{{item.txId}}</span>
                    <img src="../../../../../assets/images/procedure/preservation_img.png" alt>
                  </div>
                  <div class="swiperLine">
                    <ul>
                      <li>
                        <b></b>
                      </li>
                      <li>
                        <div class="choose">
                          <span class="showSelect"></span>
                        </div>
                      </li>
                      <li class="showSelect">
                        <b></b>
                      </li>
                    </ul>
                  </div>
                  <p class="username" v-if="item.actionType==1">{{proforeTaskVo.userName}}</p>
                  <p class="username" v-if="item.actionType==2">{{proforeTaskVo.performUserName}}</p>
                  <p class="username" v-if="item.actionType==3">{{proforeTaskVo.confirmUserName}}</p>
                  <p class="operation">
                    <span v-if="item.actionType==1">创建履约</span>
                    <span v-if="item.actionType==2">{{item.perFormStatusName}}</span>
                    <span v-if="item.actionType==3">{{item.confirmStatusName}}</span>
                    <span
                      v-if="item.perFormStatus==1&&isPerform&&index===perFormRecordList.length-1&&item.confirmStatus==0"
                      @click="showDialog(2)"
                    >撤回</span>
                  </p>
                  <p class="createdTime">{{item.cteateTime}}</p>
                </div>
              </swiper-slide>

              <!-- 没有操作的展示satart-->
              <swiper-slide
                class="swiperSlidecustomer"
                v-if="currentStatus.perFormStatus!=1&&currentStatus.perFormStatus!=3&&currentStatus.confirmStatus!=3&&(notCanRun||((!isPerform&&!isConfirm)))"
              >
                <div class="swiperCon">
                  <div class="swiperHead notSub"></div>
                  <div class="swiperLine">
                    <ul>
                      <li>
                        <b></b>
                      </li>
                      <li>
                        <div class="choose">
                          <span class="showSelect"></span>
                        </div>
                      </li>
                      <li>
                        <b></b>
                      </li>
                    </ul>
                  </div>
                  <p class="username">{{proforeTaskVo.performUserName}}</p>
                  <p class="operation">
                    <span>未提交</span>
                  </p>
                  <p class="createdTime"></p>
                </div>
              </swiper-slide>

              <swiper-slide
                class="swiperSlidecustomer"
                v-if="currentStatus.confirmStatus!=1&&currentStatus.perFormStatus!=3&&currentStatus.confirmStatus!=3&&(notCanRun||((!isPerform&&!isConfirm)))"
              >
                <div class="swiperCon">
                  <div class="swiperHead notSub"></div>
                  <div class="swiperLine">
                    <ul>
                      <li>
                        <b></b>
                      </li>
                      <li>
                        <div class="choose">
                          <span class="showSelect"></span>
                        </div>
                      </li>
                      <li>
                        <b></b>
                      </li>
                    </ul>
                  </div>
                  <p class="username">{{proforeTaskVo.confirmUserName}}</p>
                  <p class="operation">
                    <span>未确认</span>
                  </p>
                  <p class="createdTime"></p>
                </div>
              </swiper-slide>
              <!-- 没有操作的展示 end -->
              <swiper-slide
                class="swiperSlidecustomer"
                v-if="currentStatus.actionType==1&&!notCanRun&&(isPerform||isConfirm)"
              >
                <div class="swiperCon">
                  <div class="swiperHead notSub"></div>
                  <div class="swiperLine">
                    <ul>
                      <li>
                        <b></b>
                      </li>
                      <li>
                        <div class="choose">
                          <span class="showSelect"></span>
                        </div>
                      </li>
                      <li>
                        <b></b>
                      </li>
                    </ul>
                  </div>
                  <p class="username">{{proforeTaskVo.performUserName}}</p>
                  <p class="operation">
                    <span v-if="currentStatus.actionType==1">未提交</span>
                    <span v-if="isPerform" @click="showDialog(1)">提交</span>
                    <span v-if="isConfirm" @click="tipPerson">提醒</span>
                  </p>
                  <p class="createdTime"></p>
                </div>
              </swiper-slide>
              <swiper-slide
                class="swiperSlidecustomer"
                v-if="((currentStatus.actionType==3&&currentStatus.confirmStatus==2)||(currentStatus.actionType==2&&currentStatus.perFormStatus==2))&&!notCanRun&&(isPerform||isConfirm)"
              >
                <div class="swiperCon">
                  <div class="swiperHead notSub"></div>
                  <div class="swiperLine">
                    <ul>
                      <li>
                        <b></b>
                      </li>
                      <li>
                        <div class="choose">
                          <span class="showSelect"></span>
                        </div>
                      </li>
                      <li>
                        <b></b>
                      </li>
                    </ul>
                  </div>
                  <p class="username">{{proforeTaskVo.performUserName}}</p>
                  <p class="operation">
                    <span>未提交</span>
                    <span v-if="isPerform" @click="showDialog(5)">重新提交</span>
                    <span v-if="isConfirm" @click="tipPerson">提醒</span>
                  </p>
                  <p class="createdTime"></p>
                </div>
              </swiper-slide>

              <swiper-slide
                class="swiperSlidecustomer"
                v-if="(currentStatus.confirmStatus==0||currentStatus.confirmStatus==2)&&!notCanRun&&(isPerform||isConfirm)"
              >
                <div class="swiperCon">
                  <div class="swiperHead notSub"></div>
                  <div class="swiperLine">
                    <ul>
                      <li>
                        <b></b>
                      </li>
                      <li>
                        <div class="choose">
                          <span class="showSelect"></span>
                        </div>
                      </li>
                      <li>
                        <b></b>
                      </li>
                    </ul>
                  </div>
                  <p class="username">{{proforeTaskVo.confirmUserName}}</p>
                  <p class="operation">
                    <span>未确认</span>
                    <span
                      v-if="isConfirm&&currentStatus.perFormStatus==1&&currentStatus.actionType==2"
                      @click="showDialog(3)"
                    >确认</span>
                    <span
                      v-if="isConfirm&&currentStatus.perFormStatus==1&&currentStatus.actionType==2"
                      @click="showDialog(4)"
                    >驳回</span>
                    <span
                      v-if="currentStatus.perFormStatus==1&&currentStatus.confirmStatus==0&&isPerform"
                      @click="tipPerson"
                    >提醒</span>
                  </p>
                  <p class="createdTime"></p>
                </div>
              </swiper-slide>
            </swiper>

            <div class="swiper-button-pre-next" slot="button-next">
              <span class="flag"></span>
            </div>
          </div>
        </div>
        <div class="detailsFoot">
          <p>
            <img src="../../../../../assets/images/procedure/warn_icon.png">重要说明：
          </p>
          <div>
            <ul>
              <li>1、请在履约约束日期内，完成提交并确认，履约任务完成后，自动执行下一履约任务。</li>
              <li>2、如提交的任务与约定不符，任务可以驳回。</li>
              <li>3、在任务未确认前，任务可以撤回。</li>
              <li>4、被驳回、已撤回、出错的任务，任务可以重新提交。</li>
              <li>5、超出履约约束日期，任务未确认，任务为过期状态，整个合同视为违约。</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <Dialog :visible="dialogVisible" :dialogTitle="'提示'" @closeDialog="cancelFn" :width="'400px'">
      <div slot="dialog">
        <div class="hint">
          <p class="hintCon" v-if="actionType == 1">是否提交此任务？</p>
          <p class="hintCon" v-if="actionType == 2">是否撤回此任务？</p>
          <p class="hintCon" v-if="actionType == 3">是否确认此任务？</p>
          <p class="hintCon" style="width:300px;margin:0 auto" v-if="actionType == 4">
            <el-form
              ref="form"
              style="width:100%;padding-top:40px;box-sizing:border-box"
              :model="rejectForm"
              :rules="rules"
              label-width="0px"
            >
              <el-form-item prop="remark">
                <el-input v-model="rejectForm.remark" type="textarea" placeholder="请输入驳回原因"></el-input>
              </el-form-item>
            </el-form>
          </p>
          <p class="hintCon" v-if="actionType == 5">是否重新提交此任务？</p>
          <p class="authHandlerBox" style="margin: 0 auto;">
            <span class="button cursorPointer" @click="cancelFn">取消</span>
            <span class="button buttonActive cursorPointer" @click="trueSubFn">确定</span>
          </p>
        </div>
      </div>
    </Dialog>
  </div>
</template>
 <script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import BaseApi from "@lib/baseApi.js";
import Dialog from "@common/Dialog.vue";
import "swiper/dist/css/swiper.css";
import Breadcrumb from "@common/Breadcrumb.vue";
export default {
  props: ["detail"],
  data() {
    return {
      userId: localStorage.userId,
      perFormRecordList: [],
      proforeTaskVo: {},
      isConfirm: false,
      isPerform: false,
      actionType: 0,
      actionTypeMessage: "",
      ArrayFlag: ["", "提交", "撤销", "确认", "驳回", "重新提交"],
      notCanRun: false,
      currentStatus: null,
      dialogVisible: false,
      id: "",
      withdraw: true,
      subPer: true,
      alignId: "",
      result: null,
      subPerTrue: true,
      statusList: [],
      endstatus: [],
      startStatus: [],
      lastStatus: [],
      meLastIndex: "",
      stopLastIndex: "",
      returnLastIndex: "",
      activeIndex: "",
      loginUserId: "",
      showFlow: false,
      isRequest: false,
      //是否展示loading
      showLoading: false,
      swiperOption: {
        slidesPerView: "auto",
        spaceBetween: 0,
        slidesPerGroup: 1,
        loop: false,
        loopFillGroupWithBlank: true,
        navigation: {
          nextEl: ".swiper-button-pre-next",
          prevEl: ".swiper-button-pre-prev"
        }
      },
      rejectForm: {
        remark: ""
      },
      rules: {
        remark: [{ max: 50, message: "驳回原因最多50个字符", trigger: "blur" }]
      },
      isConfirm: false,
      isPerform: false
    };
  },
  created() {
    this.id = this.$route.query.id;
    if (this.$route.query.notCanRun == "Y") {
      this.notCanRun = true;
    } else {
      this.notCanRun = false;
    }
    var this_1 = this;
    this_1.init();
  },
  methods: {
    init() {
      this.showLoading = true;
      this.isRequest = true;
      var queryStr = {
        id: this.id
      };
      BaseApi.createRpcToken("/perform/performDetail", queryStr)
        .then(
          data => {
            this.result = data.datas.result.proforeTaskItemVo;
            this.proforeTaskVo = data.datas.result.proforeTaskItemVo;
            if (localStorage.userId == this.proforeTaskVo.performUserId) {
              this.isPerform = true;
            } else if (
              localStorage.userId == this.proforeTaskVo.confirmUserId
            ) {
              this.isConfirm = true;
            }
            this.perFormRecordList = data.datas.result.perFormRecord;
            this.currentStatus = this.perFormRecordList[
              this.perFormRecordList.length - 1
            ];
            this.isRequest = false;
            this.showLoading = false;
          },
          data => {
            this.isRequest = false;
            this.showLoading = false;
            console.log(data);
          }
        )
        .catch(function(e) {
          errorLog(e);
        });
    },
    cancelFn() {
      this.dialogVisible = false;
    },
    showDialog(actionType) {
      this.actionType = actionType;
      this.actionMessage = this.ArrayFlag[actionType];
      this.dialogVisible = true;
    },
    tipPerson() {
      BaseApi.createRpcToken("/perform/performRemind", {
        id: this.id
      })
        .then(
          data => {
            this.$message.success("提醒" + "成功");
            this.init();
          },
          data => {
            console.log(data);
          }
        )
        .catch(function(e) {
          errorLog(e);
        });
    },
    trueSubFn() {
      if (!this.isRequest) {
        this.isRequest = true;
        this.dialogVisible = false;
        this.showLoading = true;
        var queryStr = {
          actionType: this.actionType,
          id: this.id
        };
        this.actionType === 4 && this.rejectForm.remark
          ? (queryStr.remark = this.rejectForm.remark)
          : "";
        this.rejectForm.remark = "";
        BaseApi.createRpcToken(
          "/perform/performRecordToChain",
          queryStr,
          "post",
          false,
          false,
          false
        )
          .then(
            data => {
              this.$message.success(this.actionMessage + "成功");
              // 在init里面改变isRequest的值
              this.init();
            },
            data => {
              if (data.code == "437") {
                this.$message.error(data.message || "抱歉暂时无法处理您的请求");
                this.init();
              } else {
                this.$message.error(data.message || "抱歉暂时无法处理您的请求");
                this.isRequest = false;
                this.showLoading = false;
              }
            }
          )
          .catch(function(e) {
            errorLog(e);
          });
      }
    }
  },
  components: {
    swiper,
    swiperSlide,
    Dialog,
    Breadcrumb
  }
};
</script>
<style lang="scss">
.detailsBox {
  background: #eaedf1;
  width: 100%;
  box-sizing: border-box;
  .detailsMain {
    width: 100%;
    height: 100%;
    background: #fff;
    border-radius: 3px;
    padding: 20px;
    box-sizing: border-box;
    overflow-y: scroll;
    .detailsHead {
      width: 100%;
      height: 36px;
      padding: 8px 0;
      box-sizing: border-box;
      box-shadow: inset 0 -1px 0 0 rgba(230, 230, 230, 0.5);
      li {
        float: left;
      }
      li:nth-child(1) {
        display: block;
        width: 4px;
        height: 20px;
        background: #e88078;
        margin-right: 20px;
        border-radius: 4px;
      }
      li:nth-child(2) {
        // color:#787878;
        font-family: "PingFangSC-Medium";
      }
      li:last-child {
        color: #e88078;
      }
    }
    .detailsCon {
      width: 100%;
      .swiper-button-pre-next {
        cursor: poiner;
        margin-top: 171px;
        margin-right: 10px;
        width: 40px;
        height: 80px;
        opacity: 0.1;
        background: #000000;
        border-radius: 6px;
        display: flex;
        justify-content: center;
        align-items: center;
        .flag {
          width: 16px;
          height: 32px;
        }
        &:hover {
          opacity: 0.3;
          .flag {
            background: url(./../../../../../assets/images/personalSignDetail/right_hopv_pre.png);
            background-size: 16px 32px;
          }
        }
        .flag {
          background: url(./../../../../../assets/images/personalSignDetail/right_nor.png);
          background-size: 16px 32px;
        }
      }
      .preSwiperCom {
        width: 100%;
        display: flex;
      }
      .swiper-button-pre-prev {
        cursor: poiner;
        margin-top: 171px;
        margin-left: 10px;
        width: 40px;
        height: 80px;
        opacity: 0.1;
        background: #000000;
        border-radius: 6px;
        display: flex;
        justify-content: center;
        align-items: center;
        .flag {
          width: 16px;
          height: 32px;
        }
        &:hover {
          opacity: 0.3;
          .flag {
            background: url(./../../../../../assets/images/personalSignDetail/left_hov_pre.png);
            background-size: 16px 32px;
          }
        }
        .flag {
          background: url(./../../../../../assets/images/personalSignDetail/left_nor.png);
          background-size: 16px 32px;
        }
      }
      .detailsConHead {
        width: 100%;
        display: table;
        .el-form {
          float: left;
          width: calc(100% / 2);
          box-sizing: border-box;
          padding-top: 23px;
          .el-form-item {
            margin: 0;
            .el-form-item__label {
              width: 110px;
              line-height: 23px;
              font-size: 12px;
              color: #787878;
            }
            .el-form-item__content {
              line-height: 23px;
              font-size: 12px;
              color: #969696;
            }
          }
        }
      }
      .detailsSwiper {
        margin-top: 20px;
        width: 100%;
        overflow: hidden;
        border: 1px solid #e4e8eb;
        box-sizing: 0;
        .detailsID {
          width: 100%;
          height: 52px;
          line-height: 52px;
          background: #f0f0f0;
          font-size: 12px;
          color: #787878;
          border-bottom: 1px solid #e4e8eb;
          box-sizing: border-box;
          padding: 0 10px;
          span {
            margin-left: 10px;
          }
        }
        .swiper-container {
          margin: 0;
        }
        .swiperCustomer {
          max-width: calc(100% - 100px);
          height: 384px;
          padding: 0 10px;
          box-sizing: border-box;
          .banners {
            width: 100%;
          }

          .slidFlag {
            width: 100px;
            height: 300px;
            box-sizing: border-box;
            padding-top: 120px;
            .flag {
              display: inline-block;
              width: 100px;
              height: 4px;
              background: #e98880;
            }
          }
          .swiperSlidecustomer {
            width: 232px;
            height: 384px;
            text-align: center;
            display: flex;
            // align-items: center;
            // justify-content: center;
            padding-top: 68px;
            .swiperCon {
              overflow: hidden;
              text-align: center;
              .swiperHead {
                width: 180px;
                height: 88px;
                padding: 10px;
                margin-right: 15px;
                margin-left: 15px;
                box-sizing: border-box;
                background: #f8f8f8;
                border: 1px solid #f0f0f0;
                font-size: 12px;
                color: #646464;
                position: relative;
                word-wrap: break-word;
                word-break: normal;
                text-align: left;
                span {
                  font-size: 12px;
                  color: #969696;
                }
                img {
                  position: absolute;
                  width: 93px;
                  height: 76px;
                  right: 0;
                  top: 0;
                }
              }
              .notSub {
                background: #fff;
                border: 0;
              }
              .swiperLine {
                margin-top: 37px;
                margin-bottom: 10px;
                height: 28px;
                line-height: 28px;
                li {
                  float: left;
                }
                li:nth-child(2n-1) {
                  b {
                    display: inline-block;
                    width: 100px;
                    height: 4px;
                    background: #fbeceb;
                  }
                }
                li:nth-child(2) {
                  margin: 0 2px;
                  .choose {
                    width: 28px;
                    height: 28px;
                    span {
                      display: inline-block;
                      width: 100%;
                      height: 100%;
                      background: url("../../../../../assets/images/procedure/Circle no show_icon.png");
                      background-size: cover;
                    }
                  }
                }
              }
              .username {
                font-size: 14px;
                color: #505050;
              }
              .operation {
                height: 32px;
                background: #f0f0f0;
                width: 180px;
                border: 1px solid #ebebeb;
                text-align: center;
                line-height: 32px;
                font-size: 14px;
                margin: 10px 15px;
                span {
                  color: #787878;
                  display: inline-block;
                  margin: 0 5px;
                }
                span:not(:first-child) {
                  color: #e98880;
                }
              }
              .operations {
                span {
                  color: #e98880;
                }
              }
              .createdTime {
                line-height: 14px;
                height: 14px;
                font-size: 12px;
                color: #ea8e87;
              }
            }
          }
          .swiperSlidecustomerComplete {
            .swiperCon {
              .swiperLine {
                li:nth-child(2n-1) {
                  b {
                    display: inline-block;
                    width: 100px;
                    height: 4px;
                    background: #e98880;
                  }
                }
                .choose {
                  width: 28px;
                  height: 28px;
                  span {
                    display: inline-block;
                    width: 100%;
                    height: 100%;
                    background: url("../../../../../assets/images/procedure/Circle reach_icon.png");
                    background-size: cover;
                  }
                  .showSelect {
                    border-radius: 50%;
                    background: url("../../../../../assets/images/procedure/Circle reach_icon.png") !important;
                    background-size: 100% !important;
                  }
                }
              }
              .username {
                padding: 0 15px;
              }
            }
          }
        }
      }
      .detailsFoot {
        width: 100%;
        height: 115px;
        padding: 20px;
        box-sizing: border-box;
        background: #fafafa;
        border: 1px solid #e4e8eb;
        border-top: 0;
        // box-sizing: border-box;
        p {
          font-size: 14px;
          color: #787878;
          img {
            margin-right: 3px;
            vertical-align: middle;
          }
        }
        div {
          display: table;
          width: 100%;
          li {
            float: left;
            width: calc(100% / 2);
            font-size: 12px;
            color: #969696;
            line-height: 22px;
          }
        }
      }
    }
  }
  .hint {
    height: 200px;
    .hintCon {
      text-align: center;
      height: 137px;
      line-height: 137px;
    }
    .operate {
      padding: 0 80px;
      span {
        display: inline-block;
        width: 100px;
        height: 32px;
        text-align: center;
        line-height: 32px;
        border: 1px solid #c8c8c8;
        font-size: 12px;
        color: #646464;
      }
      span:first-child {
        border: 1px solid #db4437;
        color: #db4437;
      }
    }
  }
}
</style>

